<template>
    <painel-component :items="itemsOne">
        <form>
            <row-component>
                <row-col-component class-row-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                    <label>Código:</label>
                    <input-component v-model="formData.code" type-input="text"/>
                </row-col-component>

                <row-col-component class-row-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                    <label>Nome:</label>
                    <input-component v-model="formData.name" type-input="text"/>
                </row-col-component>

                <row-col-component class-row-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                    <label>Status:</label>
                    <Multiselect v-model="formData.status" :options="selectActiveInative" :searchable="true"
                                 :noResultsText="noResultsText" :noOptionsText="noOptionsText"/>
                </row-col-component>
            </row-component>

            <row-component>
                <row-col-component class-row-col="col-xxl-5 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <label>Criador:</label>
                    <Multiselect label="name" v-model="formData.creator_user_id" :options="selectUserList"
                                 :searchable="true" :noResultsText="noResultsText" :noOptionsText="noOptionsText"/>
                </row-col-component>

                <row-col-component class-row-col="col-xxl-5 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <label>Produto:</label>
                    <Multiselect v-model="formData.product" :options="selectBusiness" :searchable="true"
                                 :noResultsText="noResultsText" :noOptionsText="noOptionsText"/>
                </row-col-component>

                <row-col-component class-row-col="col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12 mt-xxl-4 mt-0">
                    <button-submit class="me-2" @click="submit" icon="search"/>
                    <button-route v-if="buttonCheck.create" :items="itemsTwo"/>
                </row-col-component>
            </row-component>
        </form>

        <table class="table table-striped" v-if="showLoader">
            <thead>
            <tr>
                <th scope="col" style="width: 10%">Código</th>
                <th scope="col" style="width: 16.6%">Criador</th>
                <th scope="col" style="width: 20%">Nome</th>
                <th scope="col" style="width: 16.6%">Produto</th>
                <th scope="col" style="width: 16.6%">Data/Hora de criação</th>
                <th scope="col" style="width: 16.6%" v-if="buttonCheck.edit || buttonCheck.show">
                    Ações
                </th>
            </tr>
            </thead>

            <tbody>
            <tr v-for="(data, index) in data" :key="index">
                <td data-label="Código">{{ data.code }}</td>
                <td data-label="Criador">{{ data.creator_user_name }}</td>
                <td data-label="Nome">{{ data.name }}</td>
                <td data-label="Produto">{{ stringProduct(data.product) }}</td>
                <td data-label="Data/Hora de criação">{{ data.date_create }}/{{ data.hour_create }}</td>
                <td data-label="Ações" v-if="buttonCheck.edit || buttonCheck.show">
                    <button-edit v-if="buttonCheck.edit" :id="data.id" route="contract-model-edit"/>
                    <button-show v-if="buttonCheck.show" :id="data.id" route="contract-model-show"/>
                </td>
            </tr>
            </tbody>
        </table>

        <button-pagination :pagination="object.itens" :offset="3" @paginate="loadItems"/>
    </painel-component>
</template>

<script>
import PainelComponent from "@/components/dashboard/PainelComponent";
import RowComponent from "@/components/row/RowComponent";
import RowColComponent from "@/components/row/RowColComponent";
import InputComponent from "@/components/form/InputComponent";
import Multiselect from "@vueform/multiselect";
import ButtonRoute from "@/components/buttons/ButtonRoute";
import ButtonSubmit from "@/components/buttons/ButtonSubmit";
import ButtonShow from "@/components/buttons/ButtonShow";
import ButtonEdit from "@/components/buttons/ButtonEdit";
import ButtonPagination from "@/components/buttons/ButtonPagination";

import {useToast} from "vue-toastification";

const toast = useToast()
export default {
    name: "ContractModelSearch",
    components: {
        ButtonPagination,
        ButtonEdit,
        ButtonShow,
        ButtonSubmit,
        ButtonRoute,
        Multiselect,
        InputComponent,
        RowColComponent,
        RowComponent,
        PainelComponent
    },

    created() {
        this.$store.dispatch("changeNamePage", "Modelo de Contrato")
        this.$store.dispatch("loadUserList")
        this.checkACL()
        this.loadItems(1)
    },

    data() {
        return {
            itemsOne: {
                icon: "list alternative",
                title: "Pesquisar"
            },

            itemsTwo: {
                icon: "plus",
                route: "/contract-model/create"
            },

            buttonCheck: {
                create: false,
                edit: false,
                show: false,
            },

            formData: {
                code: "",
                name: "",
                status: "",
                creator_user_id: "",
                product: "",
            },

            data: {},

            showLoader: false,
            searchSubmit: false,
        }
    },

    methods: {
        submit() {
            this.loadItems(1)
            this.searchSubmit = true;
        },

        loadItems(page) {
            if (!this.searchSubmit) {
                this.$store.dispatch("loadContractTemplates", {...this.params, page})
                    .then((r) => {
                        this.data = r.itens.data
                        if (this.searchSubmit) {
                            this.searchSubmit = false;
                            if (r.itens.data.length === 0) {
                                toast.info("Nada foi encontrado com os parâmetros informados!", {timeout: 1200});
                            }
                        }
                    }).catch(() => {
                    this.searchSubmit = false;
                });
            }
        },

        async checkACL() {
            this.$store.dispatch('ACLItems', 34)
                .then((r) => {
                    if (r.data.indexOf('contract-model-search') !== -1) {
                        this.showLoader = true
                        if (r.data.indexOf('contract-model-search') !== -1) {
                            this.buttonCheck.show = true
                        }

                        if (r.data.indexOf('contract-model-create') !== -1) {
                            this.buttonCheck.create = true
                        }

                        if (r.data.indexOf('contract-model-edit') !== -1) {
                            this.buttonCheck.edit = true
                        }
                    } else {
                        this.$router.push({name: 'home'})
                    }
                }).catch(() => {
                this.$router.push({name: 'home'})
            })
        },

        stringProduct(value) {
            if (parseInt(value) === 1)
                return "Methoduz"
            return "Tag Gold"
        }
    },

    computed: {
        noResultsText() {
            return this.$store.state.var.noResultsText
        },

        noOptionsText() {
            return this.$store.state.var.noOptionsText
        },

        selectActiveInative() {
            return this.$store.state.var.selectActiveInative
        },

        selectUserList() {
            return this.$store.state.var.selectUserList
        },

        selectBusiness() {
            return this.$store.state.var.selectBusiness
        },

        object() {
            return this.$store.state.contract_model.items
        },

        params() {
            return {
                page: this.object.current_page,
                code: this.formData.code,
                name: this.formData.name,
                status: this.formData.status,
                creator_user_id: this.formData.creator_user_id,
                product: this.formData.product,
            }
        }
    }
}
</script>